import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RelatorioRotaService {

  constructor( private readonly http: HttpClient) { }

  public postListarDepartamentos ( idEmpresa, obj ){

    return this.http.post(`/apiconnect/importation/report/smart-route/${idEmpresa}/companies`, obj, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });

  }

  public getDepartamentos ( idEmpresa ){

    return this.http.get(`/apiconnect/importation/company/departament/${idEmpresa}/companies`);

  }
}
